
import { Plus } from "@styled-icons/boxicons-regular"
import { useEffect, useContext, useState } from "react";
import {
  COLOR_PRIMARY,
  COLOR_SECONDARY,
  ContainerContent,
  HeaderPrimary,
} from "../../../component/style/content/default";
import { ButtonCardSaldo, ContainerCardSaldo, TextSaldo, Title } from "./style";
import { IdxCampaign } from "./campaign";
import { IdxStatistik } from "./statistik";
import { decrypt, DashboardService, Context } from "../../../service";
import { FormatCurrency, useTitle } from "../../../util";
import Cookies from "js-cookie";
import styled from "styled-components";
import { Modal_topup_saldo as ModalTopUpSaldo } from "../../pages/transaksi/modal/modal.topup_saldo";
import { Modal_beli_paket as ModalBeliPaket } from "../../pages/transaksi/modal/modal.beli_paket";
import * as Modal from "./modal";
import { Edit } from "@styled-icons/boxicons-solid"

const last = [
  { value: 7, label: "Last 7 days" },
  { value: 15, label: "Last 15 days" },
];

const api = DashboardService

export const IdxDashboard = () => {
  const company = Cookies.get("company") ? decrypt(Cookies.get("company")) : {};
  const company_id = Cookies.get('company_id')
  const { data_user, dispatch } = useContext(Context);
  const [data, setData] = useState({
    balance: 0,
    bucket: null,
    list: null,
  });
  const [options, setOptions] = useState({
    last: last,
  });
  const [selected, setSelected] = useState({
    last: last[0],
  });
  const [modal, setModal] = useState({
    topup: false,
    saldo: false,
    topup_paket: false,
    changeCompany: false
  });
  const [companyDetail, setCompanyDetail] = useState({})
  useTitle("Dashboard");

  const getDetailCompany = async () => {
    const { data: dataResult, success } = await api.get_company(company_id)

    if (success) {
      setCompanyDetail(dataResult)
    }
  }

  useEffect(() => {
    if (company !== null) {
      const user = DashboardService.user(company.user_id);
      if (user?.success) {
        dispatch({ type: "DATA_USER", data_user: user.data });
      }
    }

    if (company !== null) {
      DashboardService.get_balance(company_id).then((res) => {
        if (res?.success) {
          setData((state) => ({ ...state, balance: res.data }));
        }
      });

      DashboardService.get_bucket(company_id).then((res) => {
        if (res?.success) {
          setData((state) => ({ ...state, bucket: res.data }));
        }
      });
      DashboardService.get_list({
        company_id: company_id,
        last: selected.last?.value,
      }).then((res) => {
        if (res?.success) {
          setData((state) => ({ ...state, list: res.data }));
        }
      });
      getDetailCompany()
    }
    // eslint-disable-next-line
  }, []);

  const handleModalChangeCompany = (type = 'close') => {
    switch (type) {
      case 'close':
        setModal(state => ({
          ...state,
          changeCompany: false
        }))
        break;
      case 'open':
        setModal(state => ({
          ...state,
          changeCompany: true
        }))
        break;

      default:
        break;
    }

  }


  console.log({ companyDetail })
  return (
    <Container>
      <ModalTopUpSaldo
        show={modal.topup}
        onHide={() => setModal((state) => ({ ...state, topup: false }))}
      />
      <ModalBeliPaket
        show={modal.topup_paket}
        onHide={() => setModal((state) => ({ ...state, topup_paket: false }))}
      />

      <Modal.Modal_list_saldo
        show={modal.saldo}
        onHide={() => setModal((state) => ({ ...state, saldo: false }))}
        props={company ? company : {}}
      />
      <Modal.ModalChangeCompany
        show={modal.changeCompany}
        onHide={handleModalChangeCompany}
      />

      <section className="d-block mb-5">
        <div className="d-flex">
          <HeaderPrimary color={COLOR_PRIMARY}>Halo, </HeaderPrimary>
          <HeaderPrimary color={COLOR_SECONDARY}>
            {data_user.name}
          </HeaderPrimary>

        </div>
        <div className=" d-flex align-items-center gap-2">
          <h5>{companyDetail?.company_name}</h5>
          <Edit width={12} cursor="pointer" onClick={() => handleModalChangeCompany('open')} />
        </div>
      </section>

      <section className="mb-4 mb-md-4">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 mb-4 mb-md-4">
            <Title className="mb-2">Saldo Anda</Title>

            <ContainerCardSaldo
              className="d-flex align-items-center justify-content-between"
              style={{ padding: "10px" }}
            >
              <TextSaldo
                style={{ cursor: "pointer" }}
                onClick={() => setModal((state) => ({ ...state, saldo: true }))}
              >
                {FormatCurrency.currency(data.balance)}
              </TextSaldo>
              <ButtonCardSaldo
                onClick={() => setModal((state) => ({ ...state, topup: true }))}
              >
                <Plus style={{ width: "15px" }} />
                &nbsp; Top up Saldo
              </ButtonCardSaldo>
            </ContainerCardSaldo>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12">
            <Title className="mb-2">Kuota Aktif</Title>

            <ContainerCardSaldo style={{ padding: "10px" }}>
              <div>
                {data.bucket && data.bucket.length > 0 ? (
                  <div className="news">
                    <ul>
                      {data.bucket?.map((item, idx) => (
                        <li key={idx}>
                          <a>
                            {item.bucket_name} ({item.bucket_impression}{" "}
                            tersisa)
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <div className="empty">Tidak ada kuota saat ini</div>
                )}
              </div>
              <ButtonCardSaldo
                onClick={() =>
                  setModal((state) => ({ ...state, topup_paket: true }))
                }
              >
                <Plus style={{ width: "15px" }} /> &nbsp; Beli Paket
              </ButtonCardSaldo>
            </ContainerCardSaldo>
          </div>
        </div>
      </section>

      {company_id && (
        <section>
          <IdxCampaign
            setData={setData}
            data={data.list}
            options={options}
            setOptions={setOptions}
            selected={selected}
            setSelected={setSelected}
          />
        </section>
      )}

      {company_id && (
        <section>
          <IdxStatistik data={data} />
        </section>
      )}
    </Container>
  );
};

const Container = styled(ContainerContent)`
  @keyframes ticker {
    0% {
      margin-top: 0;
    }
    25% {
      margin-top: -30px;
    }
    50% {
      margin-top: -60px;
    }
    75% {
      margin-top: -90px;
    }
    100% {
      margin-top: 0;
    }
  }
  .empty {
    padding-left: 20px;
    font-size: 22px;
    color: #2dbded;
  }

  .news {
    height: 26px;
    overflow: hidden;
    -webkit-user-select: none;
  }

  .news ul {
    float: left;
    padding-left: 20px;
    animation: ticker 10s cubic-bezier(1, 0, 0.5, 0) infinite;
    -webkit-user-select: none;
  }

  .news ul li {
    line-height: 30px;
    list-style: none;
  }

  .news ul li a {
    color: #2dbded;
    text-decoration: none;
    font-size: 16px;
  }

  .news ul:hover {
    animation-play-state: paused;
  }
`;
